import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/AuthReducer/action';
import { toast } from 'react-toastify';

const IDLE_TIMEOUT_MS = (() => {
  const val = Number(process.env.REACT_APP_IDLE_TIMEOUT_MS);
  return !isNaN(val) && val > 0 ? val : 30 * 60 * 1000;
})(); // default 30 minutes

const WARNING_BEFORE_MS = (() => {
  const val = Number(process.env.REACT_APP_WARNING_BEFORE_MS);
  return !isNaN(val) && val > 0 ? val : 60 * 1000;
})(); // default 1 minute

// const IDLE_TIMEOUT_MS = 20 * 1000;   //test
// const WARNING_BEFORE_MS = 10 * 1000;

export function useIdleLogout(enabled = true) {
  const dispatch = useDispatch();
  const timerRef = useRef(null);
  const warningRef = useRef(null);

  useEffect(() => {
    if (!enabled) return;

    const resetTimer = () => {
      clearTimeout(timerRef.current);
      clearTimeout(warningRef.current);

      warningRef.current = setTimeout(() => {
        toast.warn("You'll be logged out soon due to inactivity.");
      }, IDLE_TIMEOUT_MS - WARNING_BEFORE_MS);

      timerRef.current = setTimeout(() => {
        dispatch(logout);
        window.location.href = '/?session_expired=true';
      }, IDLE_TIMEOUT_MS);
    };

    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach((e) => window.addEventListener(e, resetTimer));
    resetTimer();

    return () => {
      events.forEach((e) => window.removeEventListener(e, resetTimer));
      clearTimeout(timerRef.current);
      clearTimeout(warningRef.current);
    };
  }, [dispatch, enabled]);
}